import header_image from "./header_image.jpeg";
import profile_image from "./profile_image.jpeg";
import about_image from "./about_image.jpeg";
import itodo_resume from "./itodo_resume.pdf";
import microfinance from "./microfinance.jpg";
import showcase from "./showcase.jpg";
import webdev from "./webdev.jpg";
import cantant from "./Cantant.png";
import jaris from "./jaris-logo2.jpg";

const assets = {
  header_image,
  profile_image,
  about_image,
  itodo_resume,
  microfinance,
  showcase,
  webdev,
  cantant,
  jaris,
};

export default assets;
